// extracted by mini-css-extract-plugin
export const hero = "x_bP";
export const hero_title = "x_bR";
export const hero_subtitle = "x_bS";
export const hero_content = "x_bQ";